<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                     Time Value                                       │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->
<template>
    <span :class="cssClasses">
        <span class="time-hour" v-if="hour">{{ hour }}</span>
        <span class="time-minute" v-if="minute">{{ minute }}</span>
        <span class="time-second" v-if="second">{{ second }}</span>
        <span class="time-am-pm" v-if="ampm">{{ ampm }}</span>
    </span>
</template>
<style scoped>
    .time-hour + .time-minute::before,
    .time-minute + .time-second::before {
        content: ':';
    }
    .time-am-pm::before {
        content: ' ';
    }
    .time-value.super .time-am-pm {
        font-size: 0.65em;
        transform: translate(-.05em);
    }
</style>
<script>
    export default {
        name: 'TimeValue',

        props: {
            value: [String, Number, Date],
            super: Boolean,
            military: Boolean,
            showSeconds: Boolean,
            showMilliseconds: Boolean
        },
        
        computed: {
            cssClasses() {
                return {
                    'time-value': 1,
                    super: this.super,
                    military: this.military
                }
            },

            time() {
                let time = this.value
                if (time) {
                    let date, parts

                    switch (time.constructor) {
                        case Date:
                            date = time
                            break
                        case Number:
                            date = new Date(time)
                            break
                        case String:
                            time = time.toUpperCase()

                            if (Date.parse(time)) date = new Date(time)
                            else if (/\d?\d(:\d\d(:\d\d(\.\d+)?)?)?\s?(AM|PM)?/.test(time)) {
                                parts = time.replace(/\s?(AM|PM)/g, '').split(/:/g).map(v => v - 0)
                                if (time.includes('PM')) parts[0] += 12
                            }
                    }

                    return date ? [date.getHours(), date.getMinutes(), date.getSeconds() + date.getMilliseconds() / 1000] : parts
                }
            },

            hour() {
                if (this.time) {
                    let hour = this.time[0]
                    if (this.military) return `${100 + hour}`.slice(1)
                    return `${hour > 12 ? hour - 12 : hour}`
                }
            },

            minute() {
                if (this.time) {
                    let minute = this.time[1] || 0
                    return `${100 + minute}`.slice(1)
                }
            },

            second() {
                if (this.time) {
                    let second = this.time[2] || 0
                    if (this.showMilliseconds) return `${100 + second}`.slice(1)
                    if (this.showSeconds) return `${100 + Math.floor(second)}`.slice(1)
                }
            },

            ampm() {
                if (this.time) {
                    if (!this.military) return this.time[0] > 12 ? 'PM' : 'AM'
                }
            }
        }
    }
</script>
